<template>
	<div v-cloak class="solution">
		<div class="banner">
			<div class="">
				<h5>解决方案</h5>
				<p>人工智能赋能精神心理疾病数字疗法</p>
			</div>
			<img src="@/assets/img_jiejue_fangan_banner.png" alt="" />
			<img src="@/assets/img_jiejue_fangan_banner_small.png" alt="" class="small" />
		</div>

		<div class="container cloudPlatform">
			<div class="content">
				<img src="@/assets/img_jiejue_fangan_tuyi.png" alt="" class="bg" />
				<div class="textarea">
					<!-- <span>解决方案</span> -->
					<h5>精神心理疾病物理治疗中心解决方案</h5>
					<p>
						基于脑功能网络控制分析，制定基于影像学特征的精准rTMS神经调控治疗策略，确定患者个性化最优靶点，云端生成治疗方案，并用于指导医生临床治疗，解决了目前精神科疾病临床物理治疗凭医生经验主观评估造成的较低治疗有效率的问题，为医院精神（心理）科室、心理诊所及第三方影像中心提供一站式解决方案。
					</p>
				</div>
				<img src="@/assets/img_jiejue_fangan_tuyi.png" alt="" class="bg" />
			</div>
		</div>
		<div class="container intervention">
			<div class="content">
				<div class="textarea">
					<!-- <span>管理解决方案</span> -->
					<h5>大规模人群心理健康筛查-干预-管理</h5>
					<p>
						依托目前世界领先的大规模心理筛查研究队列（三年20万+人次）、AI语音快速心理测评、可穿戴设备监测真实世界个人复杂行为数据AI分析、可预测个体疗效的线上CCBT治疗、虚拟现实自助心理减压VR设备等，为体检中心、大型企事业、学校、军队、公务人员、特殊人群等用户提供软硬件结合的一体化解决方案。
					</p>
				</div>
				<img src="@/assets/img_guanli_jiejue_fangan.png" alt="" class="bg" />
			</div>
		</div>
	</div>
</template>

<script>
import { GlobalMixin } from '@/util/globalMixin';
export default {
	name: 'Footer',
	mixins: [GlobalMixin]
};
</script>

<style scoped lang="less"></style>
